/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Onl_Faq_5_QInputs */

const en_vc_onl_faq_5_q = /** @type {(inputs: Vc_Onl_Faq_5_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does VectorCraft online work on a phone or iPad?`)
};

const zh_vc_onl_faq_5_q = /** @type {(inputs: Vc_Onl_Faq_5_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`手机或 iPad 能用 VectorCraft 在线版吗？`)
};

/**
* | output |
* | --- |
* | "Does VectorCraft online work on a phone or iPad?" |
*
* @param {Vc_Onl_Faq_5_QInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_onl_faq_5_q = /** @type {((inputs?: Vc_Onl_Faq_5_QInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Onl_Faq_5_QInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_onl_faq_5_q(inputs)
	return zh_vc_onl_faq_5_q(inputs)
});
export { vc_onl_faq_5_q as "vc.onl.faq.5.q" }